/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CreateAuthorizedUserUpdate,
  CreateAuthorizedUserUpdate$inboundSchema,
  CreateAuthorizedUserUpdate$Outbound,
  CreateAuthorizedUserUpdate$outboundSchema,
} from "./createauthorizeduserupdate.js";
import {
  UpdateIssuedCardState,
  UpdateIssuedCardState$inboundSchema,
  UpdateIssuedCardState$outboundSchema,
} from "./updateissuedcardstate.js";

export type UpdateIssuedCard = {
  /**
   * Updates the state of a Moov issued card.
   *
   * @remarks
   * - `closed`: The card is permanently deactivated and cannot approve authorizations. A card can be closed by request or when it expires.
   */
  state?: UpdateIssuedCardState | undefined;
  memo?: string | undefined;
  /**
   * Fields for identifying an authorized individual.
   */
  authorizedUser?: CreateAuthorizedUserUpdate | undefined;
};

/** @internal */
export const UpdateIssuedCard$inboundSchema: z.ZodType<
  UpdateIssuedCard,
  z.ZodTypeDef,
  unknown
> = z.object({
  state: UpdateIssuedCardState$inboundSchema.optional(),
  memo: z.string().optional(),
  authorizedUser: CreateAuthorizedUserUpdate$inboundSchema.optional(),
});
/** @internal */
export type UpdateIssuedCard$Outbound = {
  state?: string | undefined;
  memo?: string | undefined;
  authorizedUser?: CreateAuthorizedUserUpdate$Outbound | undefined;
};

/** @internal */
export const UpdateIssuedCard$outboundSchema: z.ZodType<
  UpdateIssuedCard$Outbound,
  z.ZodTypeDef,
  UpdateIssuedCard
> = z.object({
  state: UpdateIssuedCardState$outboundSchema.optional(),
  memo: z.string().optional(),
  authorizedUser: CreateAuthorizedUserUpdate$outboundSchema.optional(),
});

export function updateIssuedCardToJSON(
  updateIssuedCard: UpdateIssuedCard,
): string {
  return JSON.stringify(
    UpdateIssuedCard$outboundSchema.parse(updateIssuedCard),
  );
}
export function updateIssuedCardFromJSON(
  jsonString: string,
): SafeParseResult<UpdateIssuedCard, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateIssuedCard$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateIssuedCard' from JSON`,
  );
}
